module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-60x60-50234d532d841a932c45af7250a42dfd.png";